<div
  *ngIf="rss.length"
  class="relative w-full h-full rounded-2xl shadow-lg overflow-hidden row-span-1 col-span-1"
>
  <!-- Stacked items for smoother cross-fade transitions -->
  <div
    *ngFor="let item of rss; let i = index"
    class="absolute inset-0 transition-opacity duration-1000 ease-in-out"
    [class.opacity-100]="i === rssIndex"
    [class.opacity-0]="i !== rssIndex"
  >
    <img [src]="getRssImgUrl(i)" alt="" class="absolute inset-0 w-full h-full object-cover" />

    <div class="absolute bg-translucent inset-0 flex flex-col justify-end text-white p-4">
      <span class="absolute p-1 text-white top-4 right-4">{{ formatDate(item.date) }}</span>
      <span class="font-bold text-3xl">{{ item.title }}</span>
      <span class="text-sm mt-2">© ndr.de</span>
    </div>
  </div>
</div>
